import React from 'react'
import { connect } from 'react-redux'

import { selectShippingMethod } from './shippingMethodActions'

import {
  OptionListItemRadio,
  CheckoutSection,
  hiddenAnchorStyle,
  optionListItemStyle
} from '../../components'

import { Fade } from '../../../SharedComponents/componentAnimations'

const getSelectedShippingMethod = (methods, id) =>
  methods.filter(m => m.Id === id)[0];

class CheckoutShipment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
       isCollapsed: getSelectedShippingMethod(props.shippingMethods, props.selectedShippingMethodId)
    }
    this.onSelected = this.onSelected.bind(this)
  }

  onClickChange(e) {
    e.preventDefault();
    this.setState({ isCollapsed: !this.state.isCollapsed });
  }

  onSelected(id) {
    this.setState({ isCollapsed: true });
    this.props.onSelected(id);
  }

  render() {
    const shippingMethods = this.props.shippingMethods;
    const selectedId = this.props.selectedShippingMethodId;
    const selectedMethod = getSelectedShippingMethod(shippingMethods, selectedId);
    const canChange = shippingMethods.length > 1 || !selectedMethod;
    const items = !this.state.isCollapsed && shippingMethods.map(sm => {
      return (
        <OptionListItemRadio
          id={sm.Id}
          key={sm.Id}
          isSelected={(sm.Id === selectedId)}
          onClick={this.onSelected}
          label={sm.NameWithPrice}
        />
      );
    });
    return (
      <CheckoutSection label='Shipping Method' hidden={false}>
        {selectedMethod &&
          <div style={{ lineHeight: 2 }}>
            <a
              href=""
              style={hiddenAnchorStyle}
              onClick={(e) => this.onClickChange(e)}
            >
              {selectedMethod.NameWithPrice}
              {canChange &&
                <span style={{ marginLeft: 20, color: '#3cb7e3' }}>
                  {this.state.isCollapsed ? "Change" : "Done"}
                </span>}
            </a>
          </div>}
        {shippingMethods.length === 0 &&
          <div>Sorry, but no shipping methods are available.</div>}

        <Fade inProp={!this.state.isCollapsed}>
          <div>{items}</div>
        </Fade>
      </CheckoutSection>);
  }
}

const mapCheckoutShipmentStateToProps = (state) => {
  return {
    shippingMethods: state.entities.ShippingOptions,
    selectedShippingMethodId: state.entities.SelectedShippingOptionId
  }
}

const mapCheckoutShipmentDispatchToProps = (dispatch) => {
  return {
    onSelected: (id) => dispatch(selectShippingMethod(id))
  }
}

const CheckoutShipmentContainer = connect(mapCheckoutShipmentStateToProps, mapCheckoutShipmentDispatchToProps)(CheckoutShipment);

export default CheckoutShipmentContainer